export default __webpack_public_path__ + "static/media/percentage.4b27b5ae.svg";